<div
  class="flex flex-col"
  [style.height]="'calc(100svh - var(--env-banner-height, 0px))'"
>
  <header class="flex-none p-5">
    <img
      src="pkvverlag_logo.png"
      class="float-start"
    >
  </header>
  <div class="flex-1 flex flex-col items-center py-10">
    <div class="w-7/8 lg:w-3/4 xl:w-1/2">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>